import { render, staticRenderFns } from "./SwitchGroupDialog.vue?vue&type=template&id=331af75e&scoped=true"
import script from "./SwitchGroupDialog.vue?vue&type=script&lang=js"
export * from "./SwitchGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./SwitchGroupDialog.vue?vue&type=style&index=0&id=331af75e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331af75e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331af75e')) {
      api.createRecord('331af75e', component.options)
    } else {
      api.reload('331af75e', component.options)
    }
    module.hot.accept("./SwitchGroupDialog.vue?vue&type=template&id=331af75e&scoped=true", function () {
      api.rerender('331af75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/SwitchGroupDialog.vue"
export default component.exports